import { Component, OnDestroy, OnInit, HostListener, ViewChildren, QueryList } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { BasePageComponent } from '../../commons/base-page/base-page.component';
import { HelpersService } from '../../../core/helpers/helpers.service';
import { BtvDataRestService } from '../../../data/btv/btv-data-rest.service';
import { ChannelP } from '../../../data/api-client';
import { Subscription } from 'rxjs';
import { DatePipe, Location } from '@angular/common';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MetaService } from '../../../data/meta/meta.service';
import { LiveRecord } from '../../../data/btv/model/live-recording';
import { SeoService } from '../../../data/seo/seo-service.service';

declare var videojs;
declare var $: any;
declare var Glider: any;

@Component({
  selector: 'app-channel-detail',
  templateUrl: './channel-detail.component.html',
  styleUrls: ['./channel-detail.component.css']
})
export class ChannelDetailComponent extends BasePageComponent implements OnInit, OnDestroy {
  listID: string;
  public channels: Array<ChannelP> = null;
  player: any;
  index: number = 0;
  selectedChannel: ChannelP = null;
  routerSubs: Subscription;
  isMobile: boolean;
  isTablet: boolean;
  isPlay: boolean = false;
  isDesktop: boolean;
  private changeSubscription: Subscription;
  isChannelChange: boolean = false;
  liveRecords: LiveRecord[] = [];
  @ViewChildren('recordCarousel') recordCarouselItems: QueryList<any>;
  isGliderVisible: boolean;
  isFromConstructor: boolean;
  watchLiveButton: HTMLElement;
  selectedRecord: LiveRecord;
  recordsGliderSubs: Subscription;
  recordGlider: any;

  constructor(helpers: HelpersService,
    private dataSource: BtvDataRestService,
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private deviceService: DeviceDetectorService,
    //private metaService: MetaService,
    private _location: Location,
    private seoService: SeoService
  ) {
    super(helpers);

    this.isMobile = deviceService.isMobile();
    this.isTablet = deviceService.isTablet();
    this.isDesktop = deviceService.isDesktop();

    this.routerSubs = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isFromConstructor = true;
        this.listID = this.route.snapshot.paramMap.get('id');
        this.isChannelChange = false;
        this.selectedRecord = null;
        if (!!this.watchLiveButton) {
          this.watchLiveButton.style.display = 'none';
        }
        this.getChannels();
      }
    });
  }

  ngOnInit() {
    this.listID = this.route.snapshot.paramMap.get('id');
  }





  destroyPlayer() {
    if (this.selectedChannel != undefined && this.selectedChannel != null) {
      this.player.dispose();
      this.player = null;
    }
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    if (!this.isFromConstructor) {
      this.getChannels();
    }
  }


  getChannels() {
    this.dataSource.getChannels().subscribe(data => {
      this.channels = data;
      this.selectChannel();
    });
  }

  selectChannel() {
    if (this.listID == 'sportstv') {
      this.selectedChannel = this.channels.filter(channel => channel.no === 1)[0];
    }
    else if (this.listID == 'sportstvkadin') {
      this.selectedChannel = this.channels.filter(channel => channel.no === 2)[0]
    }

    if (this.selectedChannel != undefined && this.selectedChannel != null) {
      //this.metaService.updateTitle('canlı');
      //this.metaService.updateMetaInfo(this.selectedChannel.description);
      
      this.seoService.generateTags({
        title: 'canlı',
        description: this.selectedChannel.description,
        image: 'https://sportstv.com.tr/assets/images/template/sportstv-live.png',
        slug: this.listID,
        url: this.router.url
      });
      // this.getEpgDataByChannel();
      this.playPlayer();
    }
    this.isChannelChange = true;
    this.getLiveRecords();

  }

  getLiveRecords() {
    this.isGliderVisible = false;
    this.dataSource.getRecordsByChannel(this.selectedChannel.id).subscribe(data => {
      this.liveRecords = data;
      this.liveRecords = this.liveRecords.reverse();
      this.isGliderVisible = true;
      this.initRecordsGlider();
    })
  }


  initRecordsGlider() {
    this.recordsGliderSubs = this.recordCarouselItems.changes.subscribe(t => {
      if (this.isGliderVisible) {
        this.recordGlider = new Glider(document.querySelector('#record-glider'), {
          slidesToShow: 12.5,
          slidesToScroll: 1,
          draggable: true,
          rewind: true,
          duration: 1.2,
          dragVelocity: 1,
          responsive: [
            {
              // screens greater than >= 1024px
              breakpoint: 1250,
              settings: {
                slidesToShow: 11.2,
                slidesToScroll: 1,
              }
            },
            {
              // screens greater than >= 479px
              breakpoint: 479,
              settings: {
                slidesToShow: 12,
                slidesToScroll: 1,
              }
            },
            {
              // screens greater than >= 479px
              breakpoint: 0,
              settings: {
                slidesToShow: 4.5,
                slidesToScroll: 1,
              }
            },
          ],
        });
      }
    });

    if (this.isGliderVisible) {
      setTimeout(() => {
        this.scrollToLast();
      }, 50);
    }
  }

  scrollToLast() {
    this.recordGlider.scrollTo(10000);
  }

  selectRecord(record: LiveRecord) {
    this.selectedRecord = record;
    this.changePlayerSrc(record.playUrl, true);
    var thiz = this;
    this.player.one('loadedmetadata', function () {
      thiz.overlayPlayer();
    });
  }

  ngOnDestroy(): void {
    if (this.isPlay) {
      this.stopChannel();
    }
    this.destroyPlayer();

    if (this.changeSubscription) {
      this.changeSubscription.unsubscribe();
      this.changeSubscription = null;
    }
    if (this.routerSubs) {
      this.routerSubs.unsubscribe();
    }

    if (this.recordsGliderSubs) {
      this.recordsGliderSubs.unsubscribe();
      this.recordsGliderSubs = null;
    }
  }

  playPlayer() {
    setTimeout(() => {
      if (!this.player) {
        this.player = videojs('tv-player', {
          autoplay: this.isDesktop,
          controls: true,
          fluid: true,
          // overrideNative: true,
          // nativeAudioTracks: false,
          // nativeVideoTracks: false,
          // hls: {
          //     overrideNative: true,
          //   nativeAudioTracks: false,
          //   nativeVideoTracks: false,
          //   html5: {
          //       overrideNative: true,
          //     nativeAudioTracks: false,
          //     nativeVideoTracks: false
          //   }
    
          // },
          html5: {
              overrideNative: true,
            nativeAudioTracks: false,
            nativeVideoTracks: false,
            hls: {
                overrideNative: true,
              nativeAudioTracks: false,
              nativeVideoTracks: false
            },
          },
          controlBar: {
            playToggle: {
              replay: true
            },
            volumePanel: {
              inline: false
            }
          },
          liveui: true
        }
        );

        this.changePlayerSrc(this.selectedChannel.url)
        this.player.poster('assets/images/sportstv/trnsplogo.png');

      }
      else {
        this.changePlayerSrc(this.selectedChannel.url)
      }
      // this.player.removeClass('vjs-live')
      this.player.poster('assets/images/sportstv/trnsplogo.png');

      this.player.on('pause', () => {
        this.isPlay = false;
        this.stopChannel()
      })
      this.player.on('play', () => {
        this.isPlay = true;

        this.startChannel()
      })
    }, 100)
  }

  overlayPlayer() {
    
    var thiz = this;
    this.player.overlay({
      overlays: [{
        // This overlay appears at 3 seconds and disappears at 15 seconds.
        content: `
          <div id="watch-live-1" class="watch-live">
            CANLI İZLE
          </div>
                  `,
        start: 0,
        end: thiz.player.duration(),
        align: 'bottom-right',
      }]
    });

    setTimeout(() => {
      this.watchLiveButton = document.getElementById('watch-live-1');
      this.watchLiveButton.addEventListener("click", event => {
        this.changePlayerSrc(this.selectedChannel.url);
        this.watchLiveButton.style.display = "none";
        this.selectedRecord = null;
      })
    }, 100);

  }

  changePlayerSrc(source: string, buttonVisible: boolean = false) {
    this.player.src([
      { type: 'application/x-mpegURL', src: source }
    ]);

    setTimeout(() => {
      this.player.hlsQualitySelector();
    }, 250);
  }

  startChannel() {
    this.dataSource.startChannel(this.selectedChannel.id).subscribe(data => {
    })
  }

  stopChannel() {
    this.dataSource.stopChannel(this.selectedChannel.id).subscribe(data => {
    })
  }

  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {
    // if (this.isPlay) {
    this.destroyPlayer()
    this.stopChannel();
    // }
  }




  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHander(event) {
    // if (this.isPlay) {
    this.destroyPlayer()
    this.stopChannel();
    // }
  }

  locationBack() {
    if (!!sessionStorage.getItem("urlhistory") && JSON.parse(sessionStorage.getItem("urlhistory")).length < 2) {
      this.router.navigateByUrl('');
    }
    else {
      this._location.back();
    }
  }




}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/btv/channel-detail/channel-detail.component.ts